// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"cta-button_ctaButton__iOuR5","ctaButtonSmall":"cta-button_ctaButtonSmall__0Qq3S"};